import { proxyCustomElement, HTMLElement, h, Fragment } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './cl-scroll-wrapper2.js';

const clDataTableCss = ":host(cl-data-table){--data-table-border-color-selected:rgb(var(--color-brand-600));--data-table-border-color:rgb(var(--color-neutral-200));--data-table-column-width:auto;--data-table-indent-color:transparent;--data-table-max-width:100%;--data-table-padding:var(--spacing-2);--data-table-row-background-hover:rgb(var(--color-brand-100));--data-table-row-background:rgb(var(--color-neutral-50));--data-table-text-align:left;--data-table-text-wrap:wrap;--data-table-tooltip-max-width:calc(var(--size-1) * 39);border:var(--border-width) solid var(--data-table-border-color);border-radius:var(--border-radius-small);color:rgb(var(--color-neutral-900));display:flex;flex-direction:column;font-family:var(--font-family-ui);font-size:var(--font-size-body-1);max-width:var(--data-table-max-width);overflow:hidden;position:relative;table-layout:auto;width:100%}:host(cl-data-table),:host(cl-data-table) *,:host(cl-data-table) *::before,:host(cl-data-table) *::after,:host(cl-data-table) ::slotted(*),:host(cl-data-table) ::slotted(*) *,:host(cl-data-table) ::slotted(*) *::before,:host(cl-data-table) ::slotted(*) *::after{box-sizing:border-box}:host(cl-data-table) .cl-data-table__content{display:table;max-width:var(--data-table-max-width);position:relative;width:100%}:host(cl-data-table[nested=\"\"]),:host(cl-data-table[nested=true]){--data-table-indent-spacing:var(--spacing-7);--data-table-indent-color:rgb(var(--color-brand-700));border:none;border-radius:0;margin-left:var(--data-table-indent-spacing);min-width:calc(100% - var(--data-table-indent-spacing));width:-moz-fit-content;width:fit-content}:host(cl-data-table[nowrap=\"\"]),:host(cl-data-table[nowrap=true]){--data-table-text-wrap:nowrap}@supports (background: -webkit-named-image(i)){:host(cl-data-table){border-collapse:collapse}}";

const ClDataTable$1 = /*@__PURE__*/ proxyCustomElement(class ClDataTable extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    // This ensures that the slot will not be unmounted when the nested attribute changes.
    this.renderSlot = () => h("slot", { key: 'table-slot' });
    // This ensures that the content div will not be unmounted when the nested attribute changes.
    this.renderContent = () => (h("div", { key: 'table-content', class: 'cl-data-table__content' }, this.renderSlot()));
    this.nested = undefined;
    this.nowrap = undefined;
    this.rearrangable = undefined;
    this.resizable = undefined;
  }
  /**
   * Sets/unsets the rearrange attribute on the table-head-cell elements.
   */
  handleRearrangable(rearrangable) {
    var _a;
    for (const headCell of (_a = this.headCells) !== null && _a !== void 0 ? _a : []) {
      if (headCell.getAttribute('rearrange') !== 'false')
        if (rearrangable) {
          headCell.setAttribute('rearrange', '');
        }
        else {
          headCell.removeAttribute('rearrange');
        }
    }
  }
  /**
   * Sets/unsets the resize attribute on the table-head-cell elements.
   */
  handleResizable(resizable) {
    var _a;
    for (const headCell of (_a = this.headCells) !== null && _a !== void 0 ? _a : []) {
      if (headCell.cellIndex !== this.headCells.length - 1 && headCell.getAttribute('resize') !== 'false') {
        if (resizable) {
          headCell.setAttribute('resize', '');
        }
        else {
          headCell.removeAttribute('resize');
        }
      }
    }
  }
  /**
   * Every time the component is connected to the DOM:
   * -
   */
  connectedCallback() {
    var _a;
    this.headCells = (_a = this.element
      .querySelector('cl-data-table-head-row')) === null || _a === void 0 ? void 0 : _a.querySelectorAll('cl-data-table-head-cell');
  }
  /**
   * Set rearrange and resize on the children
   */
  componentDidLoad() {
    this.handleRearrangable(this.rearrangable);
    this.handleResizable(this.resizable);
  }
  render() {
    return (h(Fragment, null, h("div", null, h("slot", { name: 'bar' })), this.nested ? this.renderContent() : h("cl-scroll-wrapper", { persistent: true }, this.renderContent()), h("div", null, h("slot", { name: 'footer' }))));
  }
  get element() { return this; }
  static get watchers() { return {
    "rearrangable": ["handleRearrangable"],
    "resizable": ["handleResizable"]
  }; }
  static get style() { return clDataTableCss; }
}, [1, "cl-data-table", {
    "nested": [516],
    "nowrap": [516],
    "rearrangable": [516],
    "resizable": [516]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-data-table", "cl-scroll-wrapper"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-data-table":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClDataTable$1);
      }
      break;
    case "cl-scroll-wrapper":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const ClDataTable = ClDataTable$1;
const defineCustomElement = defineCustomElement$1;

export { ClDataTable, defineCustomElement };

//# sourceMappingURL=cl-data-table.js.map